import { createContext } from 'react'
import { User, UserRole, LoginDto, ValidateCodeDto } from '@/types'

export interface AuthContextType {
  user: User | null
  isLoading: boolean
  isAuthenticated: boolean
  login: (credentials: LoginDto) => Promise<{ code?: number }>
  validateCode: (data: ValidateCodeDto) => Promise<void>
  logout: () => void
  refreshUser: () => Promise<void>
  hasRole: (role: UserRole) => boolean
  hasAnyRole: (roles: UserRole[]) => boolean
  isAdmin: boolean
  isViewer: boolean
  isReseller: boolean
  isWholesaler: boolean
  isNeoPlatform: boolean
  isImpersonating: boolean
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)
